<template>
    <aside aria-label="Site menu">
        <slide-in-overlay :is-open="isOpen" @close="close" class="c-sitemenu">
            <template v-slot:tools> <slot name="tools"></slot></template>
            <template v-slot:body>
                <div class="c-sitemenu__toolbar c-sitemenu__toolbar--pull">
                    <div class="heading">
                        <span>
                            {{ translations['Language and currency'] }} :
                        </span>
                        {{ siteName }} / {{ selectedCurrency }}
                    </div>
                    <div
                        class="o-btn o-btn--transparent o-btn--small"
                        @click="showSelector = true"
                    >
                        {{ translations['Change'] }}
                    </div>
                </div>
                <transition name="slideleft">
                    <div class="c-sitemenu__selector" v-if="showSelector">
                        <div class="c-sitemenu__toolbar">
                            <div class="heading">
                                {{ translations['Language and currency'] }}:
                            </div>
                            <div
                                class="o-btn o-btn--small"
                                @click="updateSite()"
                            >
                                {{ translations['Save choises'] }}
                            </div>
                        </div>

                        <!-- <div
                            class="c-sitemenu__heading c-sitemenu__heading--push"
                        >
                            {{ translations['Language'] }}
                        </div>
                        <div class="c-sitemenu__list">
                            <label
                                :for="language.countryCode"
                                class="c-sitemenu__listItem"
                                v-for="language in languages"
                                :key="language.id"
                            >
                                <input
                                    type="radio"
                                    :id="language.countryCode"
                                    :value="language.countryCode"
                                    v-model="selectedLanguage"
                                    name="language"
                                />
                                <div class="label">
                                    {{ language.title }}
                                </div>
                                <div class="checkmark">
                                    <img src="/images/checkmark.svg" />
                                </div>
                            </label>
                        </div> -->

                        <div
                            class="
                                c-sitemenu__heading c-sitemenu__heading--push
                            "
                        >
                            {{ translations['Currency'] }}
                        </div>
                        <div class="c-sitemenu__list">
                            <label
                                :for="currency.iso"
                                class="c-sitemenu__listItem"
                                v-for="currency in currencies"
                                :key="currency.id"
                            >
                                <input
                                    type="radio"
                                    :id="currency.alphabeticCode"
                                    :value="currency.alphabeticCode"
                                    v-model="selectedCurrency"
                                    name="currency"
                                />
                                <div class="label">
                                    {{ translations[currency.currency] }} ({{
                                        currency.alphabeticCode
                                    }})
                                </div>
                                <div class="checkmark">
                                    <img src="/images/checkmark.svg" />
                                </div>
                            </label>
                        </div>
                    </div>
                </transition>

                <slot name="productmenu"></slot>
            </template>
            <template v-slot:secondaryBody
                ><slot name="sitemenu"></slot>
            </template>
        </slide-in-overlay>
    </aside>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import SlideInOverlay from '../components/SlideInOverlay.vue'

export default {
    name: 'SiteMenu',
    components: {
        SlideInOverlay,
    },
    data: () => {
        return {
            showSelector: false,
            selectedCurrency: '',
            selectedLanguage: '',
            initialCurrency: '',
        }
    },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        siteName: String,
        cartCurrency: String,
        currencies: [Object, Array],
        languages: [Object, Array],
        initialLanguage: String,
    },
    computed: {
        ...mapState({
            cart: (state) => state.cart.cart,
            csrf: (state) => state.app.csrfToken,
            translations: (state) => state.app.translations,
        }),
        reloadUrl: function () {
            return this.languages.find((lang) => {
                return this.selectedLanguage === lang.countryCode
            })
        },
    },
    watch: {},
    methods: {
        close() {
            this.$store.dispatch('menu/close')
            this.showSelector = false
        },
        updateSite() {
            if (this.selectedCurrency !== this.initialCurrency) {
                const formData = new FormData()
                formData.append('action', 'commerce/cart/update-cart')
                formData.append('CRAFT_CSRF_TOKEN', this.csrf)
                formData.append('paymentCurrency', this.selectedCurrency)
                formData.append('currency', this.selectedCurrency)

                axios
                    .post(document.location.href, formData)
                    .then((response) => {
                        if (response.data.success) {
                            //Reload page
                            window.location.href = this.reloadUrl.url
                            return
                        } else {
                        }
                    })
                    .catch((error) => {})
                return
            }

            if (this.selectedLanguage !== this.initialLanguage) {
                window.location.href = this.reloadUrl.url
                return
            }

            this.showSelector = false
        },
    },
    beforeMount() {
        this.initialCurrency = this.cart.currency
        this.selectedCurrency = this.cart.currency
        this.selectedLanguage = this.initialLanguage
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-sitemenu {
    &__toolbar {
        position: relative;
        margin-top: 4px;
        margin-bottom: 26px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 4px;

        &::after {
            display: block;
            position: absolute;
            content: '';
            left: -30px;
            right: -30px;
            bottom: 0;
            height: 1px;
            background: $c-light-grey;
        }

        &--pull {
            margin-top: -26px;
        }

        .heading {
            font-size: 11px;
            font-weight: bold;
            letter-spacing: -0.08px;
            line-height: 13px;
            text-transform: uppercase;
            span {
                color: $c-medium-grey;
            }
        }
    }

    &__selector {
        position: absolute;
        background: $c-white;
        top: 83px;
        left: 0px;
        right: 0px;
        bottom: 0;
        z-index: 2;
        padding: 0 30px;
    }

    &__list {
        width: 100%;
        margin-bottom: 40px;
    }

    &__listItem {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #ededed;
        transition: all $t-hover;

        &:first-child {
            padding-top: 0;
        }

        .label {
            display: inline-block;
            margin-left: 5px;
            font-size: 20px;
            letter-spacing: -0.15px;
            line-height: 20px;
            font-family: 'bebas-neue', sans-serif;
            opacity: 0.4;
            transition: all $t-hover;
        }

        input {
            position: absolute;
            display: none;

            &:checked {
                & ~ .label {
                    opacity: 1 !important;
                }
                & ~ .checkmark {
                    opacity: 1 !important;
                }
            }
        }

        .checkmark {
            opacity: 0;
        }

        &:hover {
            cursor: pointer;
            .label,
            .checkmark {
                opacity: 0.6;
            }
        }
    }

    &__heading {
        position: relative;
        margin-bottom: 16px;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: -0.07px;
        line-height: 11px;
        text-transform: uppercase;

        &--site {
            margin-top: 74px;
            &::before {
                position: absolute;
                top: -36px;
                display: block;
                content: '';
                height: 1px;
                width: calc(100% + 60px);
                left: -30px;
                right: -30px;
                background: $c-light-grey;
            }
        }

        &--push {
            padding-left: 5px;
        }
    }

    .c-slideInOverlay__inner {
        max-width: 392px;
    }
}
</style>
